import React from "react";
import { Modal, Button } from "antd";
import { ModalProps } from "antd/es/modal";
import { useTranslation } from "react-i18next";

type TButtonType = "primary" | "default" | "link" | "text" | "dashed";

interface IHrnModalProps extends ModalProps {
  open: boolean;
  title: string | React.ReactNode;
  isSubmitButton?: boolean;
  cancelButtonTitle?: string;
  isCancelButton?: boolean;
  submitButtonTitle?: string;
  submitButtonType?: TButtonType;
  isSubmitButtonDanger?: boolean;
  cancelButtonType?: TButtonType;
  isFooter?: boolean;
  footerChildren?: React.ReactNode;
  height?: number | string;
  width?: number;
  isLoading?: boolean;
  maskClosable?: boolean;
  centered?: boolean;
  destroyOnClose?: boolean;
  afterClose?: () => void;
  onCancel: () => void;
  onSave?: () => void;
}

const HrnModal: React.FC<IHrnModalProps> = ({
  open = true,
  title,
  isSubmitButton = true,
  submitButtonTitle = "Save",
  isCancelButton = true,
  cancelButtonTitle = "Cancel",
  submitButtonType = "primary",
  cancelButtonType = "default",
  isSubmitButtonDanger = false,
  isFooter = true,
  footerChildren,
  height,
  width = 740,
  isLoading = false,
  maskClosable = true,
  centered = true,
  destroyOnClose = true,
  afterClose,
  onCancel,
  onSave,
  children,
  ...modalProps
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      title={typeof (title) === "string" ? t(title) : title}
      style={{
        paddingTop: "32px",
        paddingBottom: "32px",
      }}
      width={width}
      maskClosable={maskClosable}
      centered={centered}
      destroyOnClose={destroyOnClose}
      afterClose={afterClose}
      onCancel={onCancel}
      footer={
        isFooter
          ? [
            ...(isSubmitButton
              ? [
                <Button
                  key="submit"
                  type={submitButtonType}
                  loading={isLoading}
                  disabled={isLoading}
                  onClick={onSave}
                  danger={isSubmitButtonDanger}
                >
                  {t(submitButtonTitle)}
                </Button>,
              ]
              : []),
            ...(isCancelButton
              ? [
                <Button
                  key="cancel"
                  type={cancelButtonType}
                  onClick={onCancel}
                >
                  <span className="text-primary">
                    {t(cancelButtonTitle)}
                  </span>
                </Button>,
              ]
              : []),
          ]
          : footerChildren
      }
      {...modalProps}
    >
      <div
        style={{ ...(height && { maxHeight: height, overflow: "auto" }) }}
        className={height ? "ot-modal" : ""}
      >
        {children}
      </div>
    </Modal>
  );
};

export default HrnModal;
